import { LOCALE_STORAGE_KEY, type Locale } from '@/i18n/types';

function fromNavigator(): Locale {
  const langs = typeof navigator !== 'undefined' ? navigator.languages ?? [navigator.language] : [];
  for (const raw of langs) {
    const code = (raw || '').toLowerCase();
    if (code.startsWith('vi')) return 'vi';
    if (code.startsWith('en')) return 'en';
    if (code.startsWith('ja')) return 'ja';
  }
  // Vietnam-first landing: default to Vietnamese when language is unclear.
  return 'vi';
}

export function detectInitialLocale(): Locale {
  try {
    const saved = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (saved === 'en' || saved === 'ja' || saved === 'vi') return saved;
  } catch {
    /* ignore */
  }
  return fromNavigator();
}

export function persistLocale(locale: Locale) {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    /* ignore */
  }
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale === 'ja' ? 'ja' : locale === 'vi' ? 'vi' : 'en';
  }
}
